import { ScatterplotLayer } from '@deck.gl/layers';

import type { MakeIconLayerArgs, StopType } from '@/types';
import type { PickingInfo } from '@deck.gl/core';

import {
  DEPTH,
  LOCKED_CIRCLE_LAYER,
  MAPPINGS,
  OFFSETS,
  TRAIN_CIRCLE_BORDER_LAYER,
} from '@/utils/constants/map';
import { getAtlases } from '@/utils/helpers/train-simulation/get-atlases';
import { makeIconLayer } from '@/utils/helpers/train-simulation/make-icon-layer';

export default function getStationMarkerDeckLayers(
  stationListData?: StopType[],
  onClick?: (info: PickingInfo) => boolean | void,
  isVisible: boolean = false,
  isLarge: boolean = false,
  lockedStationId?: string | number | null,
  showNonCommercial?: boolean
) {
  const atlases = getAtlases();

  if (!stationListData?.length || !atlases) {
    return [];
  }

  const getPosition = (d: StopType): [number, number] => {
    const lon = d?.hyperlinkGeographie?.lon ?? 0;
    const lat = d?.hyperlinkGeographie?.lat ?? 0;

    return [Number(lon), Number(lat)];
  };

  const layers = [];

  const baseStationData = stationListData.filter(
    (d) => showNonCommercial || d.stopType !== 'non_commercial'
  );

  const lockedStationData = lockedStationId
    ? stationListData.filter((d) => String(d.id) === String(lockedStationId))
    : [];

  const hasLockedStation = lockedStationData.length > 0;

  layers.push(
    makeIconLayer({
      id: TRAIN_CIRCLE_BORDER_LAYER,
      data: baseStationData,
      onClick,
      atlas: atlases.stationMarker,
      mapping: MAPPINGS.STATION_MARKER,
      icon: 'marker',
      color: [255, 255, 255],
      offset: [0, OFFSETS.CIRCLE],
      depth: DEPTH.CIRCLE + 0.1,
      getPosition,
      pickable: true,
      visible: isVisible,
      sizeUnits: 'meters',
      size: isLarge ? 15 : 10,
      sizeMinPixels: 10,
      sizeMaxPixels: 15,
    } as MakeIconLayerArgs)
  );

  if (hasLockedStation) {
    layers.push(
      new ScatterplotLayer<StopType>({
        id: LOCKED_CIRCLE_LAYER,
        data: lockedStationData,
        visible: isVisible,
        getPosition,
        radiusUnits: 'meters',
        radiusMinPixels: isLarge ? 12 : 8,
        radiusMaxPixels: isLarge ? 12 : 8,
        getFillColor: [255, 0, 0, 51],
        getLineColor: [255, 0, 0, 255],
        lineWidthUnits: 'pixels',
        getLineWidth: 3,
        stroked: true,
      })
    );
  }

  return layers;
}
